import { useDispatch } from "react-redux";
import { setIsLoading } from "../../../Redux/loadingSlice";
import { dateTimeLocaleFormatter } from "../../../utils/dateUtils";
import Markdown from "markdown-to-jsx";
import './historyViewer.css';
import {
    getArticle,
    getArticleHistory
} from '../../../Redux/articlesSlice';

export default function HistoryViewer(props) {
    const dispatch = useDispatch();
    const latestVersion = props.latestVersion;
    let currentVersion = props.currentVersion;

    const handleVersionChange = async (e, version) => {
        if (Number(latestVersion) > Number(version))
            await(dispatch(getArticleHistory({id: props.articleId, version: version})));
        else
            await(dispatch(getArticle({id: props.articleId})));

        currentVersion = version;
        dispatch(setIsLoading(false));
    }

    return (
        <div className="history-container">
            <div className="history-header">
                <h1>Article Edit History</h1>
            </div>
            {props.histories?.slice(0).reverse().map((history) => {
                return (
                    <div className="history-result-container" key={history.article.version}>
                        <button className={history.article.version === currentVersion ? "history-result-button-selected" : "history-result-button"} onClick={e => handleVersionChange(e, history.article.version)}>
                            <div className="header">
                                 Version {history.article.version}
                            </div>
                            Updated by {history.article.updatedBy?.name} ({history.article.updatedBy?.email}) at {dateTimeLocaleFormatter(history.article.updatedAt)}
                        </button>
                    </div>
            )})}
        </div>
    )

}